(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["pads-tech"]) return;
  try {
    
  const bundlerSlider = () => {
    new Swiper(".blundleSlider", {
      slidesPerView: 'auto',
      freeMode: true,
      keyboard: {
          enabled: true,
          onlyInViewport: true
      },
      mousewheel: {
          forceToAxis: true
      },
      // scrollbar: {
      //     el: '.blundleSlider .swiper-scrollbar',
      //     freeMode: true,
      //     draggable: true,
      //     hide: false
      // },
      watchOverflow: true,
      spaceBetween: 16,
      centerInsufficientSlides: true
    });
  };

  document.addEventListener("DOMContentLoaded", () => {
    bundlerSlider();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shop-bundle"]) return;
  try {
    
  const bundleSwiper = () => {
    new Swiper('.shop-bundle__content_mobile__swiper', {
      slidesPerView: 1,
      spaceBetween: 10,
      navigation: {
        nextEl: '.shop-bundle__content_mobile__swiper__nav .swiper-button-next',
        prevEl: '.shop-bundle__content_mobile__swiper__nav .swiper-button-prev',
      }
    })
  }
  document.addEventListener('DOMContentLoaded', () => {
    bundleSwiper()
  })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["target-fat-slider-v2"]) return;
  try {
    
  const targetFatSliderV2 = () => {
    new Swiper('.target-fat-slider-v2__swiper', {
      slidesPerView: 2.2,
      spaceBetween: 15,
      centerInsufficientSlides: true, 
      mousewheel: {
        forceToAxis: true,
      },
      breakpoints: {
        768: {
          slidesPerView: "auto",
        }
      }
    })
  }
  document.addEventListener('DOMContentLoaded', targetFatSliderV2);

  } catch(e) { console.error(e); }
})();
})();
